// extracted by mini-css-extract-plugin
export default {"animationPic":"index_animationPic_DyQj8","close":"index_close_pCYl-","open":"index_open_CybgJ"};